"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KendoLayout = void 0;
const LayoutBase_1 = require("./LayoutBase");
class KendoLayout extends LayoutBase_1.LayoutBase {
    constructor($container, centerNodeId, layoutType) {
        super($container, centerNodeId);
        this.m_layoutType = layoutType;
    }
    render(graph) {
        let that = this;
        let options = that.m_$container.data("synGraph");
        let diagram = that.m_$container.getKendoDiagram();
        if (graph.nodes.length === 0)
            return;
        // Draw nodes
        $.each(graph.nodes, (idx, node) => { that.drawNode(node); });
        that.connectGraph(graph, options);
        diagram.layout(that.getLayoutOptions());
        that.drawEdges(graph, options);
        that.drawEdgeLabels(graph, options);
        if (options.layoutType === LayoutBase_1.GraphLayoutType.Force)
            that.zoomFit();
        else
            that.panToCenterNode();
    }
    connectGraph(graph, options) {
        // Creates dummy connections for the layout algorithm
        let shapeMap = this.getShapeMap();
        let diagram = this.m_$container.getKendoDiagram();
        $.each(graph.edges, (idx, edge) => {
            diagram.connect(shapeMap[edge.data.source], shapeMap[edge.data.target]);
        });
    }
    drawEdges(graph, options) {
        let that = this;
        let diagram = that.m_$container.getKendoDiagram();
        let shapeMap = that.getShapeMap();
        // Remove dummy connections for the layout algorithm
        diagram.remove(diagram.connections, false);
        let toBackConnections = [];
        $.each(graph.edges, (idx, edge) => {
            let sourceShape = shapeMap[edge.data.source];
            let targetShape = shapeMap[edge.data.target];
            let connectionOptions = that.getConnectionOptions(options);
            let connection;
            if (options.layoutType === LayoutBase_1.GraphLayoutType.Layered) {
                if (sourceShape === targetShape) {
                    connection = diagram.connect(sourceShape.getConnector("Left"), sourceShape.getConnector("Left"), connectionOptions);
                }
                else {
                    let sourceBottom = sourceShape.getPosition("Bottom");
                    let targetTop = targetShape.getPosition("Top");
                    if (sourceBottom.y > targetTop.y) {
                        connection = diagram.connect(sourceShape.getConnector("Auto"), targetShape.getConnector("Auto"), connectionOptions);
                    }
                    else {
                        let midPoints = [];
                        if (sourceBottom.x === targetTop.x) {
                            midPoints = [];
                        }
                        else {
                            let midY = targetTop.y - that.m_layerSeparation / 2; // (targetTop.y - sourceBottom.y) / 2;
                            midPoints = [
                                new kendo.dataviz.diagram.Point(sourceBottom.x, midY),
                                new kendo.dataviz.diagram.Point(targetTop.x, midY)
                            ];
                        }
                        connection = diagram.connect(sourceShape.getConnector("Bottom"), targetShape.getConnector("Top"), $.extend(true, connectionOptions, { points: midPoints }));
                    }
                }
            }
            else {
                if (sourceShape !== targetShape) {
                    connection = diagram.connect(sourceShape.getConnector("Auto"), targetShape.getConnector("Auto"), connectionOptions);
                    toBackConnections.push(connection);
                }
            }
            if (connection != undefined)
                that.setConnectionDataItemProperty(connection, "edge", edge.data);
        });
        if (toBackConnections.length)
            diagram.toBack(toBackConnections, false);
    }
    dotProduct(v1, v2) {
        return v1.x * v2.x + v1.y * v2.y;
    }
    getLayoutOptions() {
        if (this.m_layoutType === LayoutBase_1.GraphLayoutType.Force) {
            return {
                type: "force",
                nodeDistance: 450
            };
        }
        else { // GraphLayoutType.Layered
            return {
                type: "layered",
                subtype: "down",
                nodeDistance: this.m_layerNodeDistance,
                layerSeparation: this.m_layerSeparation
            };
        }
    }
}
exports.KendoLayout = KendoLayout;
